import React from "react";
import MainContainer from "../MainContainer";
import ESChatContext from "../../context/ChatContext/ESChatContext";
import useAuthenticatedContainerData from "./useAuthenticatedContainerData";

const AuthenticatedContainer = () => {
  const { isLoading, isRegistered } = useAuthenticatedContainerData();

  // TODO: RealTimeProvider will wrap this container to provided RealTime capabilities only when users is successfully authenticated
  return (
    <ESChatContext>
      <MainContainer isLoading={isLoading} isRegistered={isRegistered} />
    </ESChatContext>
  );
};

export default AuthenticatedContainer;
